import { getTimePeriodsInSeconds } from "lib/dates";

export const INTERCOM_APP_ID = "blsw8a15";

export const TIME_PERIODS = getTimePeriodsInSeconds();
